import { ClientInfoState } from "../state/clientInfoState";
import { UserAuthState } from "../state/userAuthState";
import { AxiosRequestConfig } from "axios";

export function setAuthHeaders(needsBearerToken: boolean, axiosConfig: AxiosRequestConfig) {
  if (axiosConfig.headers!["X-Client-Code?"]) {
    delete axiosConfig.headers!["X-Client-Code?"];
  }

  const clientCode = ClientInfoState.getCode();
  if (clientCode !== undefined) {
    axiosConfig.headers!["X-Client-Code"] = clientCode;
  }

  if (needsBearerToken) {
    const accessToken = UserAuthState.getAccessToken();
    if (accessToken !== undefined) {
      axiosConfig.headers!.Authorization = `Bearer ${accessToken}`;
    }
  }
  return axiosConfig;
}
